<section class="page-heading" *ngIf="originUrl">
  <a class="close-button" mat-icon-button type="button" [routerLink]="originUrl" [mat-dialog-close]="undefined">
    <mat-icon class="notranslate">close</mat-icon>
  </a>
  <h1>Opening of Bank Account failed</h1>
  <h2 class="page-sub-header">
    Your request has been rejected.<br>
    Please reach out to Covercy Customer Service.
  </h2>

  <mat-icon class="notranslate failed-icon" svgIcon="rejected"></mat-icon>
</section>
